import { useEffect, useState } from "react";
import { getSettingsData } from "../../../services/settings";
import {
  extractSettingsDocument,
  getResolvedCharacterizationViewMode,
  rememberCharacterizationViewModeFromSettings,
} from "../core/utils/characterizationViewMode";

let inflight = null;

const prefetchCharacterizationViewMode = () => {
  const resolved = getResolvedCharacterizationViewMode();
  if (resolved) return Promise.resolve(resolved);
  if (!inflight) {
    inflight = getSettingsData()
      .then((response) =>
        rememberCharacterizationViewModeFromSettings(
          extractSettingsDocument(response.data),
        ),
      )
      .catch(() => rememberCharacterizationViewModeFromSettings(null))
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

export const useCharacterizationViewMode = () => {
  const [mode, setMode] = useState(getResolvedCharacterizationViewMode);
  const [isLoading, setIsLoading] = useState(
    !getResolvedCharacterizationViewMode(),
  );

  useEffect(() => {
    let cancelled = false;
    prefetchCharacterizationViewMode().then((next) => {
      if (cancelled) return;
      setMode(next);
      setIsLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    mode,
    isLoading,
  };
};
